function renderBoldItalic(text) {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**"))
      return <strong key={i} className="font-bold">{p.slice(2, -2)}</strong>;
    if (p.startsWith("*") && p.endsWith("*") && p.length > 2)
      return <em key={i}>{p.slice(1, -1)}</em>;
    return <span key={i}>{p}</span>;
  });
}

function renderInline(text, keyPrefix = "i") {
  const parts = text.split(/(\[\^\d+\])/g);
  return parts.map((part, i) => {
    const m = part.match(/^\[\^(\d+)\]$/);
    if (m)
      return (
        <sup key={`${keyPrefix}-${i}`}>
          <a href={`#fn-${m[1]}`} data-testid={`footnote-ref-${m[1]}`}>[{m[1]}]</a>
        </sup>
      );
    return <span key={`${keyPrefix}-${i}`}>{renderBoldItalic(part)}</span>;
  });
}

export const ArticleRenderer = ({ content }) => {
  const footnotes = {};
  const blocks = [];

  content.split(/\n\s*\n/).forEach((block) => {
    const trimmed = block.trim();
    if (!trimmed) return;
    const fn = trimmed.match(/^\[\^(\d+)\]:\s*([\s\S]+)$/);
    if (fn) footnotes[fn[1]] = fn[2].trim();
    else blocks.push(trimmed);
  });

  const renderBlock = (block, idx) => {
    if (block.startsWith("### "))
      return (
        <h3 key={idx} className="text-xl sm:text-2xl font-serif font-medium text-forest mt-12 mb-6">
          {renderInline(block.slice(4), `h3-${idx}`)}
        </h3>
      );
    if (block.startsWith("## "))
      return (
        <h2 key={idx} className="text-2xl sm:text-3xl font-serif font-semibold tracking-tight text-ebony mt-14 mb-7">
          {renderInline(block.slice(3), `h2-${idx}`)}
        </h2>
      );
    if (block.startsWith("> "))
      return (
        <blockquote
          key={idx}
          className="my-12 border-l-2 border-gold pl-6 sm:pl-10 py-2"
          data-testid={`pull-quote-${idx}`}
        >
          <p className="font-serif italic text-2xl sm:text-3xl leading-snug text-forest !mb-0">
            {renderInline(block.slice(2), `q-${idx}`)}
          </p>
        </blockquote>
      );
    if (block === "---")
      return <hr key={idx} className="my-12 border-[#E2E4DC]" />;
    return <p key={idx}>{renderInline(block, `p-${idx}`)}</p>;
  };

  const fnKeys = Object.keys(footnotes).sort((a, b) => Number(a) - Number(b));

  return (
    <div className="article-body" data-testid="article-content">
      {blocks.map(renderBlock)}
      {fnKeys.length > 0 && (
        <footer className="mt-16 pt-8 border-t border-[#E2E4DC]" data-testid="article-footnotes">
          <p className="overline-label mb-6">Notas & Referências</p>
          <ol className="space-y-3">
            {fnKeys.map((n) => (
              <li
                key={n}
                id={`fn-${n}`}
                className="text-sm text-[#4D5248] leading-relaxed flex gap-3 scroll-mt-32"
              >
                <span className="font-mono text-xs text-gold mt-0.5 shrink-0">[{n}]</span>
                <span className="font-sans">{renderInline(footnotes[n], `fn-${n}`)}</span>
              </li>
            ))}
          </ol>
        </footer>
      )}
    </div>
  );
};
